import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";
import { ActivatedRoute } from "@angular/router";
import { UploadService } from "../../../../../../modules/shared/services/upload.service";
@Component({
    selector: "image-config",
    templateUrl: "./image-config.view.html",
    providers: []
})
export class ImageConfigView implements OnInit {
    baseUrl = "";
    imageConfig: any = {};
    currentLayout: string = "";
    basedOnDatas: any = [
        {
            label: "Speaker Profile Image",
            code: "speaker_img",
            type: "standard"
        },
        {
            label: "Dynamic Image",
            code: "dynamic_img",
            type: "standard"
        }
    ];

    constructor(
        public sharedService: SharedService,
        private activatedRoute: ActivatedRoute,
        private uploadService: UploadService
    ) {
        this.baseUrl = sharedService.sessionUrl;
        if (this.activatedRoute.parent.routeConfig.path == "speaker-sessions") {
            this.currentLayout = this.sharedService.sessionLayoutConfig.layout;
            this.imageConfig = this.sharedService.sessionLayoutConfig.catalogConfig[
                this.sharedService.expansionStyle
            ].imageConfig;
            if (this.sharedService.sessionFileCustomFields != null) {
                this.sharedService.sessionFileCustomFields.forEach((cf) => {
                    this.basedOnDatas.push({
                        label: cf.name,
                        code: "custom_" + cf.code,
                        type: "custom",
                        customFieldId: cf.id
                    });
                });
            }
        } else if (this.activatedRoute.parent.routeConfig.path == "speaker") {
            this.currentLayout = this.sharedService.speakerLayoutConfig[this.baseUrl].layout;

            this.imageConfig = this.sharedService.speakerLayoutConfig[this.baseUrl].catalogConfig[
                this.sharedService.expansionStyle
            ].imageConfig;

            if (this.sharedService.speakerFileCustomFields != null) {
                this.sharedService.speakerFileCustomFields.forEach((cf) => {
                    this.basedOnDatas.push({
                        label: cf.name,
                        code: "custom_" + cf.code,
                        type: "custom",
                        customFieldId: cf.id
                    });
                });
            }
        }

        if (!this.imageConfig.dynamicImage) {
            this.imageConfig.dynamicImage = "assets/images/upload-image.png";
        }

        if (!this.imageConfig.banner) {
            this.imageConfig.banner = "assets/images/upload-image.png";
        }
    }

    ngOnInit() {}

    imageChange(image) {}

    uploadEvent(file) {
        this.uploadService.fileUpload(file.formData).subscribe((resp) => {
            if (resp.body.hasOwnProperty("documentName")) {
                if (this.activatedRoute.parent.routeConfig.path == "speaker-sessions") {
                    if (this.imageConfig.basedOn === "dynamic_img") {
                        this.sharedService.sessionLayoutConfig.catalogConfig[
                            this.sharedService.expansionStyle
                        ].imageConfig.dynamicImage = resp.body["documentPath"] + resp.body["documentName"];
                    } else {
                        this.sharedService.sessionLayoutConfig.catalogConfig[
                            this.sharedService.expansionStyle
                        ].imageConfig.banner = resp.body["documentPath"] + resp.body["documentName"];
                    }
                } else if (this.activatedRoute.parent.routeConfig.path == "speaker") {
                    if (this.currentLayout != "l_banner") {
                        this.sharedService.speakerLayoutConfig[this.baseUrl].catalogConfig[
                            this.sharedService.expansionStyle
                        ].imageConfig.dynamicImage = resp.body["documentPath"] + resp.body["documentName"];
                    } else {
                        this.sharedService.speakerLayoutConfig[this.baseUrl].catalogConfig[
                            this.sharedService.expansionStyle
                        ].imageConfig.banner = resp.body["documentPath"] + resp.body["documentName"];
                    }
                }
            }
        });
    }
}
